module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "el-dialog__close el-icon el-icon-close align-right",
    staticStyle: {
      "display": "none"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "release-version"
  }, [_vm._v(_vm._s(_vm.$t('static.releaseNote.modal.versionRelease')) + " " + _vm._s(_vm.latestVersions.version))]), _vm._v(" "), (_vm.latestVersions != '') ? _c('VueSlickCarousel', _vm._b({
    ref: "carousel",
    on: {
      "afterChange": _vm.handleAfterChange
    }
  }, 'VueSlickCarousel', _vm.settings, false), [_c('div', [_c('h2', {
    staticClass: "module-title"
  }, [_vm._v(_vm._s(_vm.latestVersions.title))]), _vm._v(" "), _c('div', {
    staticClass: "module-description",
    domProps: {
      "innerHTML": _vm._s(_vm.latestVersions.excerpt)
    }
  })]), _vm._v(" "), _vm._l((_vm.latestVersions.release_modules_note), function(module, key) {
    return _c('div', {
      key: key
    }, [(module.demo_image_link != null) ? _c('img', {
      staticClass: "module-demo-image",
      attrs: {
        "src": _vm.backendUrl + '/storage/' + module.demo_image_link
      }
    }) : _vm._e(), _vm._v(" "), _c('h2', {
      staticClass: "module-title"
    }, [_vm._v(_vm._s(module.title))]), _vm._v(" "), _c('div', {
      staticClass: "module-description",
      domProps: {
        "innerHTML": _vm._s(module.excerpt)
      }
    })])
  })], 2) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "all-release"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "/#/release-notes"
    }
  }, [_vm._v(_vm._s(_vm.$t('static.releaseNote.modal.learnLink')))]), _vm._v("  \n    "), _c('span', {
    staticClass: "align-right custom-close"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-up fa-2x",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }), _vm._v(_vm._s(_vm.$t('static.releaseNote.close.gotIt')) + "  ")])]), _vm._v(" "), (_vm.latestVersions.release_modules_note && _vm.latestVersions.release_modules_note.length > 0) ? _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "release-btn-next",
    attrs: {
      "disabled": _vm.btnNextDisabled
    },
    on: {
      "click": _vm.rShowNext
    }
  }, [_vm._v(_vm._s(_vm.$t('static.releaseNote.modal.btnNext')))]), _vm._v(" "), _c('div', {
    staticClass: "release-note-pagination"
  }, [_c('span', {
    staticClass: "release-pagination"
  }, [_vm._v(_vm._s(_vm.releasePagination))])]), _vm._v(" "), _c('el-button', {
    staticClass: "release-btn-prev",
    attrs: {
      "disabled": _vm.btnPrevDisabled
    },
    on: {
      "click": _vm.rShowPrev
    }
  }, [_vm._v(_vm._s(_vm.$t('static.releaseNote.modal.btnPrev')))])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4070f36f","hasScoped":false}!./src/app/components/newReleaseVersion/newReleaseVersion.html
// module id = 2979
// module chunks = 1